import { useMutation } from '@tanstack/react-query';

import { MutationConfig } from '@/slw/shared/query-client';

import {
  login,
  register,
  resendOtp,
  changePassword,
  confirmOtpForForgotPassword,
  forgotPassword,
  verifyOtp,
} from './auth.api';

// Register
export const useRegister = (config: MutationConfig<typeof register> = {}) =>
  useMutation({
    mutationFn: register,
    ...config,
  });

// Login
export const useLogin = (config: MutationConfig<typeof login> = {}) =>
  useMutation({
    mutationFn: login,
    ...config,
  });

// Verify OTP
export const useVerifyOtp = (config: MutationConfig<typeof verifyOtp> = {}) =>
  useMutation({
    mutationFn: verifyOtp,
    ...config,
  });

// Resend OTP
export const useResendOtp = (config: MutationConfig<typeof resendOtp> = {}) =>
  useMutation({
    mutationFn: resendOtp,
    ...config,
  });

// Forgot Password
export const useForgotPassword = (config: MutationConfig<typeof forgotPassword> = {}) =>
  useMutation({
    mutationFn: forgotPassword,
    ...config,
  });

// Confirm OTP For Forgot Password
export const useConfirmOtpForForgotPassword = (config: MutationConfig<typeof confirmOtpForForgotPassword> = {}) =>
  useMutation({
    mutationFn: confirmOtpForForgotPassword,
    ...config,
  });

// Change Password
export const useChangePassword = (config: MutationConfig<typeof changePassword> = {}) =>
  useMutation({
    mutationFn: changePassword,
    ...config,
  });
